import { createBrowserRouter } from "react-router";
import AppErrorBoundary from "./AppErrorBoundary";
import {
  ANALYTICS,
  CLIENT,
  CLIENT_DETAIL,
  SUPPORT_CONTACT_US,
  CAREER,
  DASHBOARD,
  ENTRY,
  FAQ,
  FAQ_CREATE,
  FAQ_EDIT,
  FINANCIAL,
  FREELANCER,
  FREELANCER_DETAIL,
  JOB,
  JOB_DETAIL,
  PROJECT,
  PROJECT_DETAIL,
  SETTINGS,
} from "constants/url";
import AuthRoutes from "modules/auth/AuthRoutes";
import SettingsRoutes from "modules/settings/SettingsRoutes";
import CareerRoutes from "modules/career/CareerRoutes";

const router = createBrowserRouter([
  {
    path: ENTRY,
    lazy: () => import("./App"),
    ErrorBoundary: AppErrorBoundary,
    children: [
      {
        lazy: () => import("./AppPublic"),
        children: [
          {
            path: ENTRY,
            lazy: () => import("modules/auth/pages/AuthSignIn"),
          },
          {
            lazy: () => import("./modules/auth/Auth"),
            children: AuthRoutes,
          },
        ],
      },
      {
        lazy: () => import("./AppProtected"),
        children: [
          {
            path: DASHBOARD,
            lazy: () => import("modules/dashboard/Dashboard"),
          },
          {
            path: FREELANCER,
            lazy: () => import("modules/freelancer/Freelancer"),
          },
          {
            path: FREELANCER_DETAIL,
            lazy: () => import("modules/freelancer/FreelancerDetail"),
          },
          {
            path: CLIENT,
            lazy: () => import("modules/client/Client"),
          },
          {
            path: CLIENT_DETAIL,
            lazy: () => import("modules/client/ClientDetail"),
          },
          {
            path: JOB,
            lazy: () => import("modules/job/Job"),
          },
          {
            path: JOB_DETAIL,
            lazy: () => import("modules/job/JobDetail"),
          },
          {
            path: PROJECT,
            lazy: () => import("modules/project/Project"),
          },
          {
            path: PROJECT_DETAIL,
            lazy: () => import("modules/project/ProjectDetail"),
          },
          {
            path: FINANCIAL,
            lazy: () => import("modules/financial/Financial"),
          },
          {
            path: ANALYTICS,
            lazy: () => import("modules/analytics/Analytics"),
          },
          {
            path: SETTINGS,
            lazy: () => import("./modules/settings/Settings"),
            children: SettingsRoutes,
          },
          {
            path: FAQ,
            lazy: () => import("modules/faq/pages/Faq"),
          },
          {
            path: FAQ_CREATE,
            lazy: () => import("modules/faq/pages/FaqCreateUpdate"),
          },
          {
            path: FAQ_EDIT,
            lazy: () => import("modules/faq/pages/FaqCreateUpdate"),
          },
          {
            path: SUPPORT_CONTACT_US,
            lazy: () =>
              import(
                "modules/support-contact-us/pages/SupportContactUsList"
              ),
          },
          {
            path: CAREER,
            lazy: () => import("modules/career/Career"),
            children: CareerRoutes,
          },
        ],
      },
    ],
  },
]);

export default router;
